import React from "react";
import { motion } from "framer-motion";
import "../components/TermsConditions.css";
import termsImg1 from "../Assets/refund-policy.svg";
import RefundBanner from "../components/RefundBanner";

const RefundPolicy = () => {
  return (
    <>
      {/* Banner Section with Animation */}
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <RefundBanner />
      </motion.div>

      {/* Main Refund Policy Content */}
      <div className="tc-page-container">
        {/* SECTION A–C */}
        <section className="tc-section tc-section-main">
          <div className="tc-text-block tc-left">
            <h2 className="tc-title">Refund Policy</h2>

            <p className="tc-description">
              <strong style={{ color: "black" }}>A.</strong> All refund requests
              must be submitted through our official platform or customer support
              channels. Refunds are only processed after verification of eligibility
              as per our policy.
            </p>

            <p className="tc-description">
              <strong style={{ color: "black" }}>B.</strong> Refund requests will
              be evaluated on a case-by-case basis. Factors considered may include
              but are not limited to course completion, usage of materials, and
              adherence to refund request timelines.
            </p>

            <p className="tc-description">
              <strong style={{ color: "black" }}>C.</strong> If a refund is approved,
              the amount will be credited to the source account within 7 to 10 business days.
            </p>
            <p className="tc-description">
              <strong style={{ color: "black" }}>D.</strong> Refunds will not be
              granted if the request is made after the stipulated refund period
              or if the course/service has already been fully consumed. Please review
              all eligibility criteria before submitting a request.
            </p>
          </div>

          <div className="tc-image-block tc-right">
            <img src={termsImg1} alt="Refund Illustration" className="tc-image" />
          </div>
        </section>

        {/* SECTION E */}
        <section className="tc-single">
          <div className="tc-single-content">
            <p className="tc-description">
              <strong style={{ color: "black" }}>E.</strong> All refund requests
              must include valid transaction details, including payment ID, date
              of purchase, and registered user information.
            </p>
          </div>
        </section>

        {/* SECTION F */}
        <section className="tc-single">
          <div className="tc-single-content">
            <p className="tc-description">
              <strong style={{ color: "black" }}>F.</strong> Refunds will be processed
              only to the original payment method used during the purchase. No
              cash refunds or alternative credits will be provided.
            </p>
          </div>
        </section>

        {/* SECTION G – Additional Points */}
        <section className="tc-single">
          <div className="tc-single-content">
            <p className="tc-description">
              <strong style={{ color: "black" }}>G.</strong> Additional terms and conditions
              related to refunds include:
            </p>

            <ul className="tc-points-list">
              <li>Refund requests must be submitted within the specified period after purchase.</li>
              <li>Partial refunds may be granted based on usage and eligibility.</li>
              <li>Unauthorized attempts to claim refunds may lead to denial and further action.</li>
              <li>All disputes regarding refunds will be governed by the laws of India.</li>
              <li>All concerns or communications regarding refunds must be submitted using our official contact methods.</li>
              <li>If refund approved, the amount will be credited to the source account within 7 to 10 business days.</li>
            </ul>
          </div>
        </section>
      </div>
    </>
  );
};

export default RefundPolicy;
